import { Controller } from "@hotwired/stimulus";

import { fetchOptions } from "src/admin/searchable_select/fetch_options";
import { filterOptions } from "src/admin/searchable_select/filter_options";
import { parseOptionElement } from "src/admin/searchable_select/option_element";
import { SearchableSelect } from "src/admin/searchable_select/searchable_select";

export default class SearchableSelectController extends Controller<HTMLElement> {
  static targets = ["hidden", "trigger", "label", "search", "list", "status"];
  static values = {
    url: String,
    minLength: Number,
    debounce: { type: Number, default: 250 },
    blankLabel: String,
  };

  declare readonly hiddenTarget: HTMLInputElement;
  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly labelTarget: HTMLElement;
  declare readonly searchTarget: HTMLInputElement;
  declare readonly listTarget: HTMLElement;
  declare readonly statusTarget: HTMLElement;

  declare readonly urlValue: string;
  declare readonly hasUrlValue: boolean;
  declare readonly minLengthValue: number;
  declare readonly debounceValue: number;
  declare readonly blankLabelValue: string;
  declare readonly hasBlankLabelValue: boolean;

  control?: SearchableSelect;

  connect(): void {
    const remote = this.hasUrlValue && this.urlValue !== "";
    const lookup = remote
      ? (query: string) => fetchOptions(this.urlValue, query)
      : filterOptions(Array.from(this.listTarget.querySelectorAll<HTMLElement>("[role=option]")).map(parseOptionElement));

    this.control = new SearchableSelect(
      {
        root: this.element,
        hidden: this.hiddenTarget,
        trigger: this.triggerTarget,
        label: this.labelTarget,
        search: this.searchTarget,
        list: this.listTarget,
        status: this.statusTarget,
      },
      {
        lookup,
        minLength: this.minLengthValue,
        debounceMs: remote ? this.debounceValue : 0,
        blankLabel: this.hasBlankLabelValue ? this.blankLabelValue : null,
      },
    );
  }

  disconnect(): void {
    this.control?.destroy();
    this.control = undefined;
  }

  open(): void {
    this.control?.open();
  }

  close(): void {
    this.control?.close();
  }
}
